"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INIT_COORDS = 'dnd-core/INIT_COORDS';
exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
exports.HOVER = 'dnd-core/HOVER';
exports.DROP = 'dnd-core/DROP';
exports.END_DRAG = 'dnd-core/END_DRAG';



//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/lib/cjs/actions/dragDrop/types.js
// module id = 669
// module chunks = 0